export default __webpack_public_path__ + "static/media/p03 p01.73fedd38.jpg";